module.exports = __webpack_public_path__ + "img/nbus_box_object_4.fefb3898.png";